import isFixedPlan from 'utils/pivot/plan/isFixedPlan'

const getProduct = (state, config, isEnroll) => {
  if (!isEnroll) return config.product
  const plan = state.plan || state.plans[state.planId]
  const isFBM = isFixedPlan(plan)
  if (isFBM) return 'FBM'
  return config.product
}

export default getProduct
